import request from '@/utils/request'

// 获取题型列表
export function reqQuestionTypes() {
    return request({
        url: '/education/exam/paper/question-types',
        method: 'get'
    })
}

// 获取试卷状态列表
export function reqPaperStatuses() {
    return request({
        url: '/education/exam/paper/paper-statuses',
        method: 'get'
    })
}

// 生成试卷
export function generatePaper(data) {
    return request({
        url: '/education/exam/paper/generate',
        method: 'post',
        data
    })
}

// 学生开始答题
export function startAnswering(paperId) {
    return request({
        url: '/education/assessment/paper/start-answering',
        method: 'post',
        params: { paperId }
    })
}

// 学生提交答卷
export function submitPaper(paperId, answerData) {
    return request({
        url: '/education/assessment/paper/submit',
        method: 'post',
        params: { paperId, answerData }
    })
}

// 老师开始批改
export function startGrading(paperId, teacherId) {
    return request({
        url: '/education/assessment/paper/start-grading',
        method: 'post',
        params: { paperId, teacherId }
    })
}

// AI诊断分析（超时120s，因需OCR+DeepSeek分析多张图片）
export function reqAiDiagnosis(data) {
    return request({
        url: '/education/assessment/paper/ai-diagnosis',
        method: 'post',
        data,
        timeout: 120000
    })
}

// 获取AI诊断详情（每道题的详细结果）
export function reqDiagnosisDetail(paperId) {
    return request({
        url: '/education/assessment/paper/ai-diagnosis-detail/' + paperId,
        method: 'get'
    })
}

// 回退批改状态（已批改→批改中）
export function reqRollbackGrading(paperId) {
    return request({
        url: '/education/assessment/paper/rollback-grading',
        method: 'post',
        params: { paperId }
    })
}

// 获取学生待练习单词列表（用于生成试卷前展示）
export function getStudentPendingWords(studentId, params) {
    return request({
        url: '/education/assessment/student/pending-words',
        method: 'get',
        params: {
            studentId,
            ...params
        }
    })
}

// 查询学生列表（带筛选）
export function getStudentList(params) {
    return request({
        url: '/system/sysUsers/page',
        method: 'post',
        data: params
    })
}

// 查询学生的试卷列表
export function getPaperListByStudent(studentId, params) {
    return request({
        url: '/education/exam/paper/page',
        method: 'post',
        data: {
            ...params,
            studentId: studentId
        }
    })
}

// 查询试卷详情
export function getPaperDetail(paperId) {
    return request({
        url: '/education/exam/paper/detail',
        method: 'get',
        params: { id: paperId }
    })
}

// 查询试卷题目列表
export function getPaperQuestions(paperId) {
    return request({
        url: '/education/exam/paper/content',
        method: 'get',
        params: { paperId }
    })
}

// 查询试卷关联的单词信息与学生信息
export function getPaperWords(paperId) {
    return request({
        url: '/education/exam/paper/words',
        method: 'get',
        params: { paperId }
    })
}

// 方案C补偿：对指定题型重新生成并追加到已有试卷
export function regeneratePaperTypes(paperId, types) {
    return request({
        url: '/education/exam/paper/regenerateTypes',
        method: 'post',
        params: { paperId, types: types.join(',') }
    })
}

// 删除试卷
export function deletePaper(paperId) {
    return request({
        url: '/education/exam/paper/delete',
        method: 'get',
        params: { id: paperId }
    })
}

// 下载试卷（返回文件流）
export function downloadPaperStream(paperId) {
    return request({
        url: '/education/exam/paper/downloadPaper',
        method: 'get',
        params: { paperId },
        responseType: 'blob'
    })
}

export function downPaper2(paperId) {
    return request({
        url: '/education/exam/paper/cleanupAndResync',
        method: 'get',
        params: { paperId: paperId }
    })
}

// 查询学生所有单词的掌握详情
export function reqWordMasteryDetails(studentUserId) {
    return request({
        url: '/education/student/mastery/word-details',
        method: 'get',
        params: { studentUserId }
    })
}

// 批量手动更新单词掌握状态
export function reqBatchUpdateMastery(data) {
    return request({
        url: '/education/student/mastery/batch-update',
        method: 'post',
        data
    })
}

// 获取学生某分册的单词树（含掌握状态）
export function reqVolumeWords(studentUserId, gradeId, volume) {
    return request({
        url: '/education/student/mastery/volume-words',
        method: 'get',
        params: { studentUserId, gradeId, volume }
    })
}

// 级联标记掌握进度
export function reqMarkProgress(data) {
    return request({
        url: '/education/student/mastery/mark-progress',
        method: 'post',
        data
    })
}

// 重置单词学习进度（删除该学生所有单词掌握记录）
export function reqResetProgress(studentUserId, gradeId) {
    return request({
        url: '/education/student/mastery/reset-progress',
        method: 'post',
        params: { studentUserId, gradeId }
    })
}
